import { FC } from "react";

import { Icon } from "components/atoms/Icon/Icon";

import { IconType } from "@types";

import s from "./CancelButton.module.scss";

interface Props {
  disabled?: boolean;
  onClick?: () => void;
}

export const CancelButton: FC<Props> = ({
  disabled = false,
  onClick = () => console.warn("Cancel button clicked!"),
}) => {
  return (
    <button type="button" className={s.CancelButton} disabled={disabled} onClick={() => onClick()}>
      <Icon name={IconType.Cancel} size="xs" color="black" />
    </button>
  );
};
